import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import { billCommunicationActivitiesTable, billCommunicationFilesTable, billCommunicationUserNotesTable } from "../../../config/grid-column-defs";
import { getTransSalesOrderDownloadCommFile, getTransactionCommFiles, getTransactionUserNotes } from "../../../api/transaction-type";
import { getTransactionNotAvailable } from "../../../config/grid-value-formatters";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";

import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import { Box, Grid, InputLabel, MenuItem, Tabs, Tab, FormControl, Select, Stack, Button } from "@mui/material";
import TabPanel from "../../../components/TabPanel";
import useErrorHandler from "../../../hooks/useErrorHandler";

export default function RevenueArrangementCommunication({ tabIndexP }) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const [percentComplete, setPercentComplete] = useState(0);
  const errorHandler = useErrorHandler();
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];

  async function getTransactionFilesData() {
    try {
      const { data } = await getTransactionCommFiles(user?.token, {
        id: params.docNo,
      });
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false)
    }
  }

  const getDownloadDocumentById = (id, filename, folder) => {
    if (!filename) {
      snackbar.showInfo("No files.");
      return;
    }
    setDialogOpen(true);
    setPercentComplete(0);

    const options = {
      // Defines options for request

      headers: {
        authorization: user?.token,
      },
      responseType: "blob",
      // For a file (e.g. image, audio), response should be read to Blob (default to JS object from JSON)

      onDownloadProgress: function (progressEvent) {
        const newPercentComplete = Math.floor(
          (progressEvent.loaded / progressEvent.total) * 100
        );
        setPercentComplete(newPercentComplete); // Update the percentComplete state
      },
    };
    setDownloadInProgress(true); // Start the download progress
    getTransSalesOrderDownloadCommFile(user?.token, options, {
      id: id,
      // folderpath: isFilename === true ? "" : filename,
      // filename: isFilename === true ? encodedFilename : "",
    }, {
      filename: filename,
      folderpath: folder
    })
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob.data);
        link.setAttribute("download", `${filename.replace(".html",".pdf")}`);
        document.body.appendChild(link);
        link.click();
        setDialogOpen(false);
      })
      .catch((err) => {
        errorHandler(err);
        setDownloadInProgress(false);
        setDialogOpen(false);
        snackbar.showError("File does not exist");
      })
      .finally(() => {
        setDownloadInProgress(false);
        setDialogOpen(false);
        // Download completed or errored, stop progress
      });
  };

  async function getTransactionUserNotesData() {
    try {
      const { data } = await getTransactionUserNotes(user.token, {
        id: params.docNo,
      });
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
     // setLoading(false);
    }
  }

  return (
    <>
      <Box>
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className="tabs-sub-bkg"
        >
          <Tab label="Activities" />
          <Tab label="User Notes" />
          <Tab label="Files" />
        </Tabs>

        {/*----------Activities------------*/}
        <TabPanel value={tabIndex} index={0}>
          <Box className="viewDetilsBox">
            <Grid container spacing={2} pb={2}>
              <Grid item xs={12} sm={4} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value=""
                    label="VIEW"
                  >
                    <MenuItem value="Default View">Default View</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">STATUS</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value=""
                    label="VIEW"
                  >
                    <MenuItem value="Default View">Default View</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">
                    ACTIVITY TYPE
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value=""
                    label="VIEW"
                  >
                    <MenuItem value="Default View">Default View</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Box
              sx={{
                backgroundColor: "#bbd9e8",
                p: 1,
              }}
            >
              <Stack spacing={2} direction="row">
                <Button className="blue-button">New Event</Button>
                <Button className="blue-button">Log Event</Button>
                <Button className="blue-button">View History</Button>
                <Button className="blue-button">Customize View</Button>
              </Stack>
            </Box>
            <AgGridPaginatedTable
              getTableRows={getTransactionNotAvailable}
              columns={billCommunicationActivitiesTable}
              refreshCounter={0}
            />
          </Box>
        </TabPanel>
         {/* ----------User Notes------------ */}
         <TabPanel value={tabIndex} index={1}>
          <Box className="viewDetilsBox">
            <Grid container spacing={2} py={2}>
              <Grid item xs={12} sm={4} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value=""
                    label="VIEW"
                  >
                    <MenuItem value="Default View">Default View</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              backgroundColor: "#bbd9e8",
              p: 1,
            }}
          >
            <Stack spacing={2} direction="row">
              <Button className="blue-button">New Note</Button>
              <Button className="blue-button">View History</Button>
              <Button className="blue-button">Customize View</Button>
            </Stack>
          </Box>
          <AgGridPaginatedTable
            getTableRows={getTransactionUserNotesData}
            columns={billCommunicationUserNotesTable}
            refreshCounter={0}
          />
        </TabPanel>
        {/*----------Files------------*/}
        <TabPanel value={tabIndex} index={2}>
          <Box className="viewDetilsBox">
            {
              user.token && <AgGridPaginatedTable
                getTableRows={getTransactionFilesData}
                columns={billCommunicationFilesTable}
                refreshCounter={0}
                onCellClicked={(params) => {
                  console.log("Prarams-===", params);
                  if (params.colDef.field === "transaction_id") {
                    getDownloadDocumentById(
                      params.data.transaction_id,
                      params.data.filename,
                      params.data.folder
                    );
                  }
                  return;
                }}
              />
            }
          </Box>
        </TabPanel>
       

      </Box>
    </>
  );
}
